var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextStyle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.598V3.88c0-.573.236-1.123.658-1.529a2.301 2.301 0 011.592-.633h16.5c.597 0 1.17.228 1.592.633.422.406.659.956.658 1.529v.72M12 1.718v21.6m-4.5 0h9",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#1253F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgTextStyle;